import type {CssValue} from '../../constants'
import {deserializeFunction, serializeFunction} from './function'

export const OVERRIDE_FUNCTION_NAME: string = 'overrides'

interface CssOverride {
    value: string
    overrides: string[]
}

export const serializeOverride = ({value, overrides}: CssOverride): CssValue =>
    serializeFunction({name: OVERRIDE_FUNCTION_NAME, args: [value, ...overrides]})

export const deserializeOverride = (val: CssValue): CssOverride | undefined => {
    const func = deserializeFunction(val)
    if (!func) {
        return undefined
    }

    const {name, args} = func
    if (name !== OVERRIDE_FUNCTION_NAME || args.length < 2) {
        return undefined
    }

    const [value, ...overrides] = args

    return {
        value,
        overrides
    }
}
